import React from "react";
import { connect } from "react-redux";
import ReactPlayer from "react-player";
import hv_player_api from "../../api/hv_player_api";
import { playMedium } from "../../api/media";
import actions from "../../redux/actions";

class HvPlayer extends React.Component {
  state = { played: [] };
  componentDidUpdate = async prevProps => {
    if (
      prevProps.progress !== this.props.progress &&
      this.props.progress &&
      this.props.progress.playedSeconds > 20 &&
      !this.state.played.includes(this.props.currently_playing.id)
    ) {
      await this.setState({
        played: [...this.state.played, this.props.currently_playing.id]
      });
      playMedium(this.props.currently_playing.id);
    }

  };


  render() {
    return (
      <ReactPlayer
        url={this.props.currently_playing && this.props.currently_playing.url}
        playing={this.props.playing}
        volume={this.props.volume.percentile / 100}
        muted={this.props.volume.muted}
        progressInterval={500}
        className="d-none"
        autoPlay
        playsinline
        {...hv_player_api.reactPlayerProps}
      />
    );
  }
}
export default connect(state => state)(HvPlayer);
